import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './campaign-state.scss';

type Props = {
  state: string,
  message: string
};

const CampaignState = (
  {
    state,
    message
  }: Props
): JSX.Element => {
  const stateNameClasses = classnames({
    'campaign-state__name': true,
    [`campaign-state__name--${state}`]: true
  });

  const icons = {
    draft: {
      name: 'circle-custom-fg',
      color: 'grey-light'
    },
    preparation: {
      name: 'circle-custom-fg',
      color: 'blue'
    },
    active: {
      name: 'dot-inside-circle-custom-fg',
      color: 'primary'
    },
    inactive: {
      name: 'checkmark-inside-circle-custom-fg',
      color: 'primary'
    }
  };

  return (
    <div className="campaign-state__title">
      <span className="campaign-state__icon">
        <SVGDynamicIcon
          name={`${icons[state].name}`}
          width={22}
          height={22}
          customColor={icons[state].color}
        />
      </span>
      <span className={stateNameClasses}>
        {message}
      </span>
    </div>
  );
};

export default CampaignState;
